import { getPath } from '@/router/common'

const baseUrl = {
  title: '双联开票',
  path: 'SLManage'
}

export default [
  {
    path: getPath('DriverAddPage', baseUrl),
    name: 'SLManage_DriverAddPage',
    component: () => import(/* webpackChunkName: "SLManage_DriverAddPage" */ '@/views/sLManage/driverAddPage/index.vue'),
    meta: {
      title: '认证司机'
    }
  },
  {
    path: getPath('DriverIndex', baseUrl),
    name: 'SLManage_DriverIndex',
    component: () => import(/* webpackChunkName: "SLManage_DriverIndex" */ '@/views/sLManage/driverIndex/index.vue'),
    meta: {
      title: '司机列表'
    }
  },
  {
    path: getPath('CarAddPage', baseUrl),
    name: 'SLManage_CarAddPage',
    component: () => import(/* webpackChunkName: "SLManage_CarAddPage" */ '@/views/sLManage/carAddPage/index.vue'),
    meta: {
      title: '认证车辆'
    }
  },
  {
    path: getPath('CarIndex', baseUrl),
    name: 'SLManage_CarIndex',
    component: () => import(/* webpackChunkName: "SLManage_CarIndex" */ '@/views/sLManage/carIndex/index.vue'),
    meta: {
      title: '车辆列表'
    }
  },
  {
    path: getPath('OrderList', baseUrl),
    name: 'SLManage_OrderList',
    component: () => import(/* webpackChunkName: "SLManage_OrderList" */ '@/views/sLManage/orderList/index.vue'),
    meta: {
      title: '订单列表'
    }
  },
  {
    path: getPath('ToBeBillingList', baseUrl),
    name: 'SLManage_ToBeBillingList',
    component: () => import(/* webpackChunkName: "SLManage_ToBeBillingList" */ '@/views/sLManage/toBeBillingList/index.vue'),
    meta: {
      title: '待申请开票列表'
    }
  },
  {
    path: getPath('BillingList', baseUrl),
    name: 'SLManage_BillingList',
    component: () => import(/* webpackChunkName: "SLManage_BillingList" */ '@/views/sLManage/billingList/index.vue'),
    meta: {
      title: '已申请开票列表'
    }
  },
  {
    path: getPath('SLOrderList', baseUrl),
    name: 'SLManage_SLOrderList',
    component: () => import(/* webpackChunkName: "SLManage_SLOrderList" */ '@/views/sLManage/sLOrderList/index.vue'),
    meta: {
      title: '查看订单记录'
    }
  },
  {
    path: getPath('SubmitTaxPayPage', baseUrl),
    name: 'SLManage_SubmitTaxPayPage',
    component: () => import(/* webpackChunkName: "SLManage_SubmitTaxPayPage" */ '@/views/sLManage/submitTaxPayPage/index.vue'),
    meta: {
      title: '线下付款'
    }
  },
  {
    path: getPath('GetPayListPage', baseUrl),
    name: 'SLManage_GetPayListPage',
    component: () => import(/* webpackChunkName: "SLManage_GetPayListPage" */ '@/views/sLManage/getPayListPage/index.vue'),
    meta: {
      title: '查看支付信息'
    }
  }
]
